import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { AppErrorMessagesComponent } from '../../../../../../../../base/error-messages/app-error-messages.component';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';

@Component({
    selector: 'app-tiered-price-form',
    templateUrl: './tiered-price-form.component.html',
    styleUrls: ['./tiered-price-form.component.scss'],
    imports: [ReactiveFormsModule, NumericTextBoxModule, AppErrorMessagesComponent, TranslateModule]
})
export class TieredPriceFormComponent implements OnInit {

  @Input() public tieredPriceForm: UntypedFormGroup;

  public isAdd = true;

  constructor() { }

  public get formFields() {
    return this.tieredPriceForm?.controls;
  }

  ngOnInit() {
    this.isAdd = !this.tieredPriceForm.value.id;
  }

  public isMultipleOfLinearPriceStep(): boolean {
    if (!!this.tieredPriceForm.controls.amountOfMinutes.value && !!this.tieredPriceForm.controls.minStepInMinutes.value) {
      return this.tieredPriceForm.controls.amountOfMinutes.value % this.tieredPriceForm.controls.minStepInMinutes.value !== 0;
    }
    return false;
  }

}
